module.exports = __webpack_public_path__ + "static/media/1_A1_22.2f225c9a.png";